import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Title = styled.span`
  padding: 10px;
  margin-left: 5px;
  flex: 1;
  font-weight: ${props => (props.isParent ? "bold" : "none")};
`;

export const Icon = styled(FontAwesomeIcon)`
  padding: 10px;
  color: white;
`;

export const ArrowIcon = styled(FontAwesomeIcon)`
  color: white;
  margin-right: 5px;
`;

export const ChildrenContainer = styled.div`
  min-width: max-content;
  transition: all 0.3s ease-in-out;
  z-index: 9;
  box-sizing: border-box;
  background-color: ${props => props.theme.colors.midNightBlue};
  color: white;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  display: ${props => {
    const isDisplay = props?.isOpen && props.open;
    return isDisplay ? "flex" : "none";
  }};
  opacity: ${props => (props?.isOpen ? 1 : 0)};
  visibility: ${props => (props?.isOpen ? "visible" : "hidden")};
  flex-direction: column;
`;

const sidebarChildControlStyles = css`
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
  border: 0;
  background-color: transparent;
  font: inherit;
  text-align: left;
  :hover {
    background-color: ${props => props.theme.colors.lightMidNightBlue};
  }
`;

export const ItemChildren = styled.button`
  ${sidebarChildControlStyles}
  color: ${props =>
    props?.selected ? props.theme.colors.green : props.theme.colors.white};
  padding: 10px;
  padding-left: 20%;
`;

export const NestedGroupContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const NestedDisclosure = styled.button`
  ${sidebarChildControlStyles}
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  padding-left: calc(20% + ${props => 3 + props.$depth * 12}px);
  color: ${props =>
    props?.selected ? props.theme.colors.green : props.theme.colors.white};
`;

export const NestedChildren = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NestedContractContainer = styled.div`
  width: 100%;

  > nav {
    width: 100%;
    max-width: none;
    color: white;
  }

  > nav > button,
  > nav a {
    ${sidebarChildControlStyles}
    min-height: 0;
    border-radius: 0;
    padding: 10px;
    padding-left: calc(20% + 15px);
    color: white;
    font-weight: 400;
    text-decoration: none;
  }

  > nav > ul {
    padding: 0;
  }

  > nav a {
    padding-left: calc(20% + 27px);
  }

  > nav a[aria-current="page"] {
    border-left: 0;
    background: transparent;
    color: ${props => props.theme.colors.green};
    font-weight: 400;
    white-space: nowrap;
  }

  > nav a[aria-current="page"] span {
    font-size: 10px;
  }

  > nav > button:focus,
  > nav a:focus {
    outline: none;
  }

  > nav > button:focus-visible,
  > nav a:focus-visible {
    background-color: ${props => props.theme.colors.lightMidNightBlue};
  }
`;

export const ChildrenIcon = styled.span`
  font-weight: bold;
`;

export const ListItem = styled.button`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: ${props =>
    props?.selected ? props.theme.colors.lightGreen : "transparent"};
  justify-content: ${props => (props?.open ? "flex-start" : "center")};
  border-top: ${props => `solid 0.05px ${props.theme.colors.black}`};
  color: white;
  margin: 0;
  padding: 0;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  font: inherit;
  text-align: left;
  cursor: pointer;
  svg {
    min-width: 15.99px;
    max-width: 15.99px;
  }
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  :hover {
    background-color: ${props => props.theme.colors.lightMidNightBlue};
    color: white;
  }
`;
